import { useCallback } from "react";
import { getMeUser } from "../Services_V2/Auth.service";
import useAuth from "./useAuth";

const useGetUser = () => {
    const { dispatch } = useAuth();

    const refreshUser = useCallback(async () => {
        const userRes = await getMeUser();

        if (!userRes) return;

        dispatch({
            type: "updateState",
            payload: {
                user: userRes.user,
                userOrganization: userRes.entityDetails,
            },
        });

        return userRes;
    }, [dispatch]);

    return refreshUser;
};

export default useGetUser;
